import { IconName } from '@bytel/trilogy-assets/lib/iconNameEnum';

import { FaqConfig } from '@app-types/eligibility/config';

import { LegalsSlugType, PAGE_SLUG } from '@helpers/partials';
import { paths } from '@helpers/path';

import { PlanTypeId } from '@constants/plan';
import { BUTTON_STYLE, ELIGIBILITY_JOURNEY } from '@constants/provider';

import { EligibilityJourneyConfig } from './eligibility-config';

export class ExtraBboxJourneyConfig extends EligibilityJourneyConfig {
    protected readonly name = ELIGIBILITY_JOURNEY.EXTRA_BBOX;
    protected readonly offerCategoryCodeToShow: PlanTypeId = PlanTypeId.FAI_EXTRA_BOX;
    protected readonly hideForecast = true;
    protected readonly showComparatorSelection: boolean = false;
    protected readonly eligBlock = {
        hideEligibilityTypeSelector: true,
        eligibilityCtaLabel: 'En profiter',
    };
    protected readonly wordings = {
        mainTitle: 'Extra Bbox,\nvotre WiFi de secours en 5G',
        overrideShortListTitle: true,
        subtitle: 'Merci de renseigner votre adresse pour continuer :',
        noFiber: "En attendant l'arrivée de la fibre...",
    };
    protected readonly faq: FaqConfig = {
        title: "Des questions sur l'Extra Bbox\u00A0?\nOn vous répond",
        path: PAGE_SLUG.EXTRA_BBOX,
        isHiddenBeforeTest: true,
    };
    protected readonly legalsPath: LegalsSlugType = PAGE_SLUG.BOX_5G;
    protected readonly tracking = {
        page: 'Eligibilite_test_extra_bbox',
        pageCategory: 'Eligibilite',
        eCommerceStep: '',
        universe: 'Boutique_Fai',
        marketLine: 'Fai',
        variant: {
            type_offres: 'Offres_extra_bbox',
        },
        variables: {
            type_offres: 'Offres_extra_bbox',
        },
    };
    protected readonly mismatch = {
        icon: IconName.EXCLAMATION_CIRCLE,
        alertTitle: "La 4G/5G est nécessaire pour profiter de l'offre",
        alertDescription: "En attendant d'être éligible, vous pouvez voir les offres disponibles chez vous.",
        showAddress: true,
        showDivider: false,
        trackingClic: {
            event: 'clic',
            actionClic: 'Clic_redirection',
            categorieClic: 'Non_eligible_extra_bbox',
            nomClic: 'Voir_les_offres',
        },
        trackingImpression: {
            categorieClic: 'Poppin_eligibilite_ko_extra_bbox',
            nomClic: 'Eligibilite_ko_extra_bbox',
        },
        buttonLabel: 'Voir les offres disponibles',
        buttonStyle: BUTTON_STYLE.PRIMARY,
        ctaRedirectUrl: paths.eligibilityTest,
    };
    protected readonly extraCmsBlockByTab = {};
}
